import { render, staticRenderFns } from "./report-info.vue?vue&type=template&id=6ef1d986&scoped=true&"
import script from "./report-info.vue?vue&type=script&lang=ts&"
export * from "./report-info.vue?vue&type=script&lang=ts&"
import style0 from "./report-info.vue?vue&type=style&index=0&id=6ef1d986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef1d986",
  null
  
)

export default component.exports